// App.js
import React, { createContext, useState } from "react";

import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "./styles/globals.css";

import HomePage from "./pages/index";
import UpdatePage from "./pages/classroom";
import Assignments from "./pages/classroom/assignments";
import Assignment from "./pages/classroom/assignments/[id]";
import Units from "./pages/classroom/units";
import Calendar from "./pages/classroom/calendar";
import Lesson from "./pages/classroom/lesson/[id]";
import Admin from "./pages/admin";
import NotFound from "./pages/404";

// supa secret page
import SecretPage from "./_SECRET_PAGE";

const App = () => {
    return (
        <Router>
            <Routes>
                <Route path="*" element={<NotFound />} />

                <Route path="/secret_page101" element={<SecretPage />} />

                <Route path="/" element={<HomePage />} />
                <Route path="/math150" element={<UpdatePage />} />
                <Route path="/math150/assignments" element={<Assignments />} />
                <Route
                    path="/math150/assignments/:id"
                    element={<Assignment />}
                />
                <Route path="/math150/units" element={<Units />} />
                <Route path="/math150/calendar" element={<Calendar />} />
                <Route path="/math150/lesson/:id" element={<Lesson />} />

                <Route path="/admin" element={<Admin />} />

                <Route path="/math254" element={<UpdatePage />} />
                <Route path="/math254/assignments" element={<Assignments />} />
                <Route
                    path="/math254/assignments/:id"
                    element={<Assignment />}
                />
                <Route path="/math254/units" element={<Units />} />
                <Route path="/math254/calendar" element={<Calendar />} />
                <Route path="/math254/lesson/:id" element={<Lesson />} />

            </Routes>
        </Router>
    );
};

export default App;
